import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';
import {UserAccount} from '../../../__generated__/resolvers-types';
import NotAuthenticatedPage from '../../other/NotAuthenticatedPage';
import useEnvironmentSecrets from '../../../hook/useEnvironmentSecrets';

export interface EnvironmentProps {
  user: UserAccount | null | undefined;
}

export default function Environment({user}: EnvironmentProps) {
  const {data, loading, error} = useEnvironmentSecrets();

  if (!user) {
    return <NotAuthenticatedPage />;
  }

  if (!user.permissions?.includes('owner')) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom>
          Environment
        </Typography>
        <Typography color="text.secondary">You do not have permission to view this page.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Environment
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Backend config keys and masked values. Admin only.
      </Typography>
      {loading && <Typography>Loading…</Typography>}
      {error && (
        <Typography color="error" paragraph>
          {error}
        </Typography>
      )}
      {!loading && !error && data.length > 0 && (
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
          <TableContainer component={Paper} variant="outlined" sx={{maxWidth: 480}}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>key</TableCell>
                  <TableCell>value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow key={row.key}>
                    <TableCell>{row.key}</TableCell>
                    <TableCell>{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
      {!loading && !error && data.length === 0 && <Typography color="text.secondary">No entries.</Typography>}
    </Box>
  );
}
